import SectionImg from "../../common/images/pos-LastSec.png";
import WStepOne from "../../common/images/wstep1.png";
import WStepTwo from "../../common/images/wstep2.png";
import WSepThree from "../../common/images/wstep3.png";
export default function Work() {
  const features = [
    {
      img: WStepOne,
    },
    {
      img: WStepTwo,
    },
    {
      img: WSepThree,
    },
  ];
  return (
    <div className="max-w-[1280px] mx-auto md:px-10 px-5 py-7">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="md:text-5xl text-3xl font-bold">How It Works</h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
     
      </div>
      <div className="mt-6 max-w-[1280px] mx-auto  small:flex hidden justify-center">
          <img
            src={SectionImg}
            alt="Illustration"
            className="w-full px-5  object-contain"
          />
        </div>
        <div className="px-5 small:hidden grid xs:grid-cols-2 grid-cols-1 gap-3 text-center">
      {features.map((feature, index) => (
        <div key={index}>
          <img
            src={feature.img.src || feature.img}
            alt={feature.title}
            className="size-auto mb-4"
          />
        </div>
      ))}
    </div>
       
      </div>
  );
}
